import { type Kitchen, NoteType } from '@rta/rta-blueprint-library';

import { overrideToPlainText } from '../shared/sanitize-override-html';

export type GetMaxRevisionNumberParams = {
	kitchen: Kitchen | null;
};

/**
 * Returns the largest numeric Rev value shown in the revision-log table
 * (note-derived rows overlaid with `revision.{index}.rev` blueprint
 * overrides), or null when no Rev cell holds a number yet.
 */
export const getMaxRevisionNumber = (params: GetMaxRevisionNumberParams): number | null => {
	const { kitchen } = params;
	if (!kitchen) return null;

	const revValues: Record<number, string> = {};
	const revisionNoteCount = kitchen.notes?.children.filter((note) => note.type === NoteType.Revision).length ?? 0;
	for (let row = 1; row <= revisionNoteCount; row++) revValues[row] = row.toString();

	Object.entries(kitchen.blueprintOverrides ?? {}).forEach(([key, value]) => {
		const match = key.match(/^revision\.(\d+)\.rev$/);
		if (match) revValues[Number(match[1])] = value;
	});

	const numbers = Object.values(revValues)
		.map((value) => parseInt(overrideToPlainText(value).replace(/[^0-9]/gu, ''), 10))
		.filter((value) => !isNaN(value));

	return numbers.length > 0 ? Math.max(...numbers) : null;
};
